import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { ChildPagesForm } from '../forms/ChildPagesForm';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';

export function ChildPagesEdit({ form }: { form: ChildPagesForm['form'] }) {
  const { delayedRefresh } = useRefreshBlock();
  return <ChildPagesForm form={form} refreshBlock={delayedRefresh} />;
}

export const ChildPagesEditView = asFetchableView(ChildPagesEdit);
export type ChildPagesEditView = ComponentProps<typeof ChildPagesEditView>;
